class BundleSelects extends HTMLElement {
  constructor() {
    super();
    this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.totalPrice = 0;
    this.soundbar = this.dataset.soundbar === 'true';
  }

  connectedCallback() {
    this.fieldsets.forEach((fieldset) => {
      fieldset.selectedOptions = [];

      fieldset.addEventListener('change', (event) => {
        if (event.target.type === 'radio') {
          this.updateSelectedOption(fieldset, event.target);
        } else if (event.target.type === 'checkbox') {
          this.updateCheckboxOption(fieldset, event.target);
        }
      });

      // Handle initially selected radio buttons
      const initialSelectedRadios = fieldset.querySelectorAll(
        'input[type="radio"]:checked'
      );
      initialSelectedRadios.forEach((selectedElement) => {
        this.updateSelectedOption(fieldset, selectedElement);
      });

      // Handle initially selected checkboxes
      const initialSelectedCheckboxes = fieldset.querySelectorAll(
        'input[type="checkbox"]:checked'
      );
      initialSelectedCheckboxes.forEach((selectedElement) => {
        this.updateCheckboxOption(fieldset, selectedElement);
      });
    });

    this.logSelectedOptions();
  }

  updateSelectedOption(fieldset, selectedElement) {
    fieldset.selectedOptions = Array.from(
      fieldset.querySelectorAll('input[type="radio"]:checked')
    );
    this.logSelectedOptions();
  }

  updateCheckboxOption(fieldset, selectedElement) {
    fieldset.selectedOptions = Array.from(
      fieldset.querySelectorAll('input[type="checkbox"]:checked')
    );
    this.logSelectedOptions();
  }

  logSelectedOptions() {
    let combinedSelectedOptionsData = [];

    this.fieldsets.forEach((fieldset) => {
      const fieldsetSelectedOptionsData = Array.from(fieldset.selectedOptions)
        .map((element) => {
          try {
            return JSON.parse(element.dataset.option);
          } catch (error) {
            console.error('Error parsing JSON:', error);
            console.error('Original string:', element.dataset.option);
            return null;
          }
        })
        .filter((option) => option !== null);

      combinedSelectedOptionsData = combinedSelectedOptionsData.concat(
        fieldsetSelectedOptionsData
      );
    });

    this.selectedOptionsData = combinedSelectedOptionsData;
    this.updateTotalPrice();
    this.handleCoverOptionsVisibility();
  }

  handleCoverOptionsVisibility() {
    const withSoundbarElements = document.querySelectorAll('.with_soundbar');
    const withoutSoundbarElements =
      document.querySelectorAll('.without_soundbar');

    const soundbarSelected = this.selectedOptionsData.some(
      (option) => option.name.toLowerCase().indexOf('soundbar') > -1
    );

    if (soundbarSelected) {
      withSoundbarElements.forEach(
        (element) => (element.style.display = 'block')
      );
      withoutSoundbarElements.forEach(
        (element) => (element.style.display = 'none')
      );
    } else {
      withSoundbarElements.forEach(
        (element) => (element.style.display = 'none')
      );
      withoutSoundbarElements.forEach(
        (element) => (element.style.display = 'block')
      );
    }
  }

  updateTotalPrice() {
    const bundleSelects = document.querySelectorAll('bundle-selects');
    let totalPrice = 0;
    if (bundleSelects.length === 0) {
      return;
    }

    bundleSelects.forEach((bundleSelect) => {
      if (!bundleSelect.selectedOptionsData) {
        return;
      }
      bundleSelect.selectedOptionsData.forEach((option) => {
        totalPrice += option.price;
      });
    });

    this.totalPrice = totalPrice;

    const bundlePriceElements = document.querySelectorAll('.bundle_price');
    bundlePriceElements.forEach((element) => {
      const price = parseFloat(element.getAttribute('data-price'));
      element.textContent = `$${((price + this.totalPrice) / 100)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
    });
  }
}

customElements.define('bundle-selects', BundleSelects);
